module.exports = __webpack_public_path__ + "img/hongbaotrue@3x.08b938de.png";